var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expandv2"},on:{"leave":_vm.leave,"enter":_vm.enter}},[(_vm.visible)?_c('div',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }